import authReducer from './reducer';
import { configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    auth:authReducer
    },
});

export default store;
